import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

import { InputRenderer } from '../types';

const ToggleGroup = ({ inputProps, options }: InputRenderer) => {
  return (
    <>
      <ToggleButtonGroup {...inputProps} aria-labelledby={`${inputProps.name}-label`}>
        {options?.map((option) => (
          <ToggleButton color="primary" key={option.key} sx={{ flexGrow: 1 }} value={option.key}>
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  );
};

export default ToggleGroup;
